import { render, staticRenderFns } from "./EditPromotion.vue?vue&type=template&id=493144a4&scoped=true&"
import script from "./EditPromotion.vue?vue&type=script&lang=js&"
export * from "./EditPromotion.vue?vue&type=script&lang=js&"
import style0 from "./EditPromotion.vue?vue&type=style&index=0&id=493144a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493144a4",
  null
  
)

export default component.exports